import { HubFeature } from '@ats/api/cm';
import { LocDefs, LocDisplayType, LocMap, MapLocKeys } from '@cm/core/localization';

const pathStart = 'Tools|Exams Under Review|Confirmation Modal|';

export type SPReviewConfirmModalLocNames =
	| 'SPReviewConfirmModalButtonConfirm'
	| 'SPReviewConfirmModalLabelNotify'
	| 'SPReviewConfirmModalLabelComments'
	| 'SPReviewConfirmModalButtonCancel'
	| 'SPReviewConfirmModalErrorRequired'
	| 'SPReviewConfirmModalTitleValidation'
	| 'SPReviewConfirmModalTitleInValidation';

export const spReviewConfirmModalLocs: LocDefs<SPReviewConfirmModalLocNames> = {
	SPReviewConfirmModalButtonConfirm: {
		defaultValue: 'Confirm',
		description: 'Button to confirm the review',
		displayPath: `${pathStart}Confirm`,
		displayType: 'Button' as LocDisplayType,
		feature: HubFeature.BulkCandidateTools,
		portal: 'SP',
	},
	SPReviewConfirmModalButtonCancel: {
		defaultValue: 'Cancel',
		description: 'Button to cancel the review',
		displayPath: `${pathStart}Cancel`,
		displayType: 'Button' as LocDisplayType,
		feature: HubFeature.BulkCandidateTools,
		portal: 'SP',
	},
	SPReviewConfirmModalLabelComments: {
		defaultValue: 'Comments',
		description: 'Label for field: Comments',
		displayPath: `${pathStart}Comments`,
		displayType: 'Label' as LocDisplayType,
		feature: HubFeature.BulkCandidateTools,
		portal: 'SP',
	},
	SPReviewConfirmModalLabelNotify: {
		defaultValue: 'Notify Candidate',
		description: 'Label for field: Notify Candidate',
		displayPath: `${pathStart}Notify`,
		displayType: 'Label' as LocDisplayType,
		feature: HubFeature.BulkCandidateTools,
		portal: 'SP',
	},
	SPReviewConfirmModalErrorRequired: {
		defaultValue: 'This field is required',
		description: 'Error when a required field is empty',
		displayPath: `${pathStart}Comments Required`,
		displayType: 'Label' as LocDisplayType,
		feature: HubFeature.BulkCandidateTools,
		portal: 'SP',
	},
	SPReviewConfirmModalTitleValidation: {
		defaultValue: 'Confirm Validation',
		description:
			'Title of the pop-up dialog requesting confirmation to validate/invalidate exams',
		displayPath: `${pathStart}Dialog Title Validation`,
		displayType: 'Content' as LocDisplayType,
		feature: HubFeature.BulkCandidateTools,
		portal: 'SP',
	},
	SPReviewConfirmModalTitleInValidation: {
		defaultValue: 'Confirm Invalidation',
		description:
			'Title of the pop-up dialog requesting confirmation to validate/invalidate exams',
		displayPath: `${pathStart}Dialog Title Invalidation`,
		displayType: 'Content' as LocDisplayType,
		feature: HubFeature.BulkCandidateTools,
		portal: 'SP',
	},
};

export const LOC_KEYS = MapLocKeys<SPReviewConfirmModalLocNames>(spReviewConfirmModalLocs);
export type SPReviewConfirmModalLocType = LocMap<SPReviewConfirmModalLocNames>;
